module.exports = __webpack_public_path__ + "img/Academico_Environment.01db49bf.png";